<template>
	<el-dialog :title="showTitle" :visible.sync="dialogAddShow" width="60%" :before-close="handleClose"
		:close-on-click-modal="false">
		<el-form :rules="userRules" label-position="right" ref="addForm" :model="addForm" label-width="70px"
			class="postForm">
			<el-form-item label="编码名称:" label-width="150px" prop="keyName">
				<el-input v-model="addForm.keyName" auto-complete="off" class="formItem" size="small" maxLength="50" />
			</el-form-item><el-form-item label="开头编码:" label-width="150px" prop="startNumber">
				<el-input v-model="addForm.startNumber" auto-complete="off" class="formItem" size="small" maxLength="10" />
			</el-form-item><el-form-item label="中间规则类型:" label-width="150px" prop="centerNumberRule">
				<el-select v-model="addForm.centerNumberRule" placeholder="请选择" size="small">
					<el-option v-for="item in centerNumberRuleDict" :key="item.valuekey" :label="item.textkey"
						:value="item.valuekey">
					</el-option>
				</el-select>
			</el-form-item><el-form-item label="结尾流水号:" label-width="150px" prop="endNumber">
				<el-input v-model="addForm.endNumber" auto-complete="off" class="formItem" size="small" maxLength="50" />
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="handleClose()" size="small">取 消</el-button>
			<el-button type="primary" @click="handleSubmit()" size="small">确 定</el-button>
		</div>
	</el-dialog>
</template>
<script>
export default {
	name: "addSave",
	props: ["showTitle", "dialogAddShow", "mid"],
	data() {
		return {
			addForm: {
				id: 0,
				keyCode: '',
				keyName: '',
				startNumber: '',
				centerNumberRule: '',
				endNumber: '',

			},
			roleIDsDict: [],
			userRules: {},
			centerNumberRuleDict: [{valuekey:0,textkey:"无"},{  valuekey: 1, textkey: '年月日（yyyyMMdd)' }, { valuekey: 2, textkey: '年月日（yyMMdd)' },
			{ valuekey: 3, textkey: '年月（yyyyMM)' }, { valuekey: 4, textkey: '年月（yyMM)' }, { valuekey: 5, textkey: '年（yyyy)' }]
		};
	},
	watch: {
		dialogAddShow: {
			handler(newVal, oldVal) {
				if (newVal) {
					this.initData();
				}
			},
			deep: true
		}
	},
	methods: {
		initData() {
			this.$axios.get("/basic/getbasic_primaryinfo?id=" + this.mid + "&rnd=" + new Date().getTime())
				.then(res => {
					this.addForm = res.data.data;
					this.loadDict();
				});
		},
		loadDict() {
		},
		handleClose() {
			this.$emit("getVisible", false);
		},
		handleSubmit() {
			this.$refs.addForm.validate(valid => {
				if (valid) {

					let formData = this.$util.jsonToForm(this.addForm);
					this.$axios.post("/basic/basic_primarysave", formData).then(res => {
						if (res.data.status == 0) {
							this.$message("保存成功!");
							this.$emit("saveCallBack");
						} else {
							this.$message(res.data.msg);
						}
					});

				} else {
					return false;
				}
			});
		}
	}
};
</script>

<style lang="less" scoped></style>

